


















































import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            // These two variables are used to show the user the date they selected in the v-expansion-panel header
            dateChoiceStart: '',
            dateChoiceEnd: '',

            // These two variables are used to disable or enable their respective expansion panels preventing the user from
            // changing the dates in a way that could cause errors
            disableEndDateChoice: true,
            disableStartDateChoice: false,

            // In order to programmatically close/open a expansion panel you need a v-model (what this var is) which is essentially
            // an array of our expansion panels which you can then toggle open/closed by adding or removing them from this array
            expansionPanelsOpened: [0],

            // These start out blank as the user hasn't chosen a date but when they do the string is filled with the date/time they choose
            previousStartDateForCalender: '',
            previousEndDateForCalender: ''
        }
    },
    mounted() {
        // This is used for our expansion panel to show the user what date they picked
        // We need to use substr here as datepicker needs a less precise datetime object
        this.previousStartDateForCalender = this.payload.startDate.substr(0, 10)
        this.previousEndDateForCalender = this.payload.endDate.substr(0, 10)
    },
    computed: {
        // Minimum date user can select in the start date calender (when tenant was created)
        minDateStartCalender(): string {
            return this.$store.getters.tenant.created_at
        },
        // Max date user can select which is current day
        maxDateBothCalenders(): string {
            return new Date().toISOString()
        },
        // This is used so when the start date is chosen and the end date calender opens the earliest date you can choose is what was choosen in the
        // start date calender
        minDateEndCalender(): string {
            return this.dateChoiceStart
        },
        // Returns our messagestable.ts payload object which we use to paginate our filters
        payload(): object {
            return this.$store.getters.messagesTableParams
        }
    },
    methods: {
        // Resets all the data properties to give us a clean slate so user can rechoose dates
        resetChoices(): void {
            // Reset the start/end date selction text that is shown to the user
            this.dateChoiceStart = ''
            this.dateChoiceEnd = ''

            // We disable the user from editing the end date
            this.disableEndDateChoice = true

            // We enable the user to edit the start date again
            this.disableStartDateChoice = false

            // We close the end date panel and open the start date panel to direct user to make their choices again
            this.expansionPanelsOpened = [0]
        },
        // Sets the selected date and then closes the panel and opens the end date panel
        selectedDateStart(usersSelectedDate: string): void {
            // Set the start date text to what the user choose date wise
            this.dateChoiceStart = usersSelectedDate

            // We enable the user to now choose an end date
            this.disableEndDateChoice = false

            // We disable the startdate choice selection since the user already choose a date
            this.disableStartDateChoice = true

            // We open the end date panel automatically and close the start date panel
            this.expansionPanelsOpened = [1]
        },
        // Sets the selected date and then closes the end date panel
        selectedDateEnd(usersSelectedDate: string): void {
            // We set the end date choice text to date user choose
            this.dateChoiceEnd = usersSelectedDate

            // We disable the end date selection as they have choosen a date
            this.disableEndDateChoice = true

            // We close the end date panel so now both panels are closed (user can choose to reset selction or submit)
            this.expansionPanelsOpened = []
        },
        // Updates the store with the user's date choices which are used to paginate the data and closes the pop-up this component was called from
        // (DataTableHeader.vue)
        submit(): void {
            // We update our store payload so we can filter based off the user's choices
            this.payload.startDate = this.dateChoiceStart
            this.payload.endDate = this.dateChoiceEnd

            // Always return user to page 1 if they have applied a date filter to prevent 2-1 page error
            this.payload.messagesCurrentPage = 1
            this.payload.page = 1

            // We update our store with the date changes
            this.$store.commit('messagesTableParamsSet', this.payload)

            // We then filter and paginate our table based off the dates given
            this.$store.dispatch('messagesTableMessagesPaginate')

            // We close the dialog app from where this component was called
            this.$store.dispatch('dialogClose', 'APP')
        }
    }
})
